import * as React from 'react';

import { PrivacyPageLocale, NumberedListProps } from './privacyPage.locale';
import Header from '../Header/Header';
import List from '../List/List';

import styles from './PrivacyPage.scss';

interface PrivacyPageProps {
  locale: PrivacyPageLocale;
}

const PrivacyPage: React.SFC<PrivacyPageProps> = ({ locale }) => {
  const numberedList = (listItems: NumberedListProps[] | string[]): any => {
    return (
      <ol className={styles.numberedList}>
        {Object.values(listItems).map((item, index) => (
          <li key={index} className={styles.numberedListItem}>
            {item.title && <h4>{item.title}</h4>}
            {item.text && <p>{item.text}</p>}
            {item.numberedList ? (
              numberedList(item.numberedList)
            ) : (
              <p className={styles.text} dangerouslySetInnerHTML={{ __html: item }} />
            )}
          </li>
        ))}
      </ol>
    );
  };

  return (
    <>
      <Header title={locale.title} small />
      <main className="container py-7 py-md-8">
        <div className={styles.container}>
          {locale.policies.map((policy, index) => (
            <div
              key={policy.title}
              className={`${index !== locale.policies.length - 1 && 'mb-5 mb-md-6'}`}
            >
              <h4 className="mb-2">{policy.title}</h4>
              {policy.description && (
                <p
                  className={`${policy.list && 'mb-4'}`}
                  dangerouslySetInnerHTML={{ __html: policy.description }}
                />
              )}
              {policy.list && <List items={policy.list} />}
              {policy.afterListDescription && (
                <p
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: policy.afterListDescription }}
                />
              )}
              {policy.numberedList && numberedList(policy.numberedList)}
            </div>
          ))}
        </div>
      </main>
    </>
  );
};

export default PrivacyPage;



// WEBPACK FOOTER //
// /www/client/src/components/PrivacyPage/PrivacyPage.tsx